module.exports = __webpack_public_path__ + "img/my-profile.798edf37.svg";